import { useCallback } from "react";
import { humanizeErrorMessage } from "../../lib/error-utils";

export function useChatError(sdkError: Error | undefined, reload: () => void) {
    const displayError = humanizeErrorMessage(sdkError?.message);
    const isError = !!sdkError;

    const handleRetry = useCallback(() => {
        reload();
    }, [reload]);

    return {
        displayError,
        isError,
        handleRetry,
    };
}
